import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Dropdown, NavDropdown, Navbar, Nav, NavLink } from 'react-bootstrap';
import { FaBell, FaBullhorn, FaFileAlt } from 'react-icons/fa';
import { validatePermission } from 'actions/index';
import Text from '../Text';
import Tooltip from '../Tooltip';
import Notifications, { useNotificationsController } from './Notifications';
import * as Controller from './controller';
import * as Styled from './styles';
import Company from './Company';

export default function Menu({ title }) {
  const [versionState, setVersionState] = useState(JSON.parse(localStorage.getItem('version')));
  const versionTime = `${import.meta.env.VITE_BUILD_NUMBER}`;
  const { unread, fetchUnreadNotifications } = useNotificationsController();

  const app_version = `${import.meta.env.VITE_BUILD_NUMBER || 'dev'}`;
  const user = JSON.parse(localStorage.getItem('usuario'));
  useEffect(() => {
    fetchUnreadNotifications();
  }, []);

  return (
    <>
      <Styled.Navbar sticky="top" collapseOnSelect expand="lg">
        <Navbar.Brand id="menu-inicio" href="/" className="mr-3 menu-logo">
          <img
            src="/images/Logo-Cooperplace-Branca.png"
            alt="logo escrito Cooperplace"
            className="mb-1"
            width="170px"
          />
        </Navbar.Brand>
        {title && (
          <Styled.CenterTitle>
            <Text type="subtitle" color="white">
              {title}
            </Text>
          </Styled.CenterTitle>
        )}
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav" className="nav-header">
          <div
            style={{
              display: 'flex',
              width: '100%',
              justifyContent: 'flex-end',
              gap: 12,
              alignItems: 'center',
            }}
          >
            {validatePermission('VER_ATUALIZACOES') && (
              <Dropdown>
                <Tooltip
                  content={<Text type="label">Confira as ultimas atualizações do sistema</Text>}
                  placement="bottom"
                >
                  <NavLink
                    className="menu-top-icon"
                    onClick={() => {
                      setVersionState(versionTime);
                      Controller.versionUpdate(versionTime);
                    }}
                    target="_blank"
                    href="https://coopercarga.sharepoint.com/sites/cooperplacenews?OR=Teams-HL&CT=1706613390339&clickparams=eyJBcHBOYW1lIjoiVGVhbXMtRGVza3RvcCIsIkFwcFZlcnNpb24iOiI0OS8yNDAxMDQxOTExNCIsIkhhc0ZlZGVyYXRlZFVzZXIiOmZhbHNlfQ%3D%3D"
                  >
                    <FaBullhorn color="#fff" size={18} />
                    {app_version !== versionState ? <Styled.VersionUnreadIcon /> : ''}
                  </NavLink>
                </Tooltip>
              </Dropdown>
            )}
            {validatePermission('REVISAR_DOCUMENTOS') && (
              <Tooltip content={<Text type="label">Revisar documentos</Text>} placement="bottom">
                <NavLink as={Link} to="/revisar-documentos" className="menu-top-icon">
                  <FaFileAlt color="#fff" size={18} />
                </NavLink>
              </Tooltip>
            )}
            <Dropdown>
              <Dropdown.Toggle
                as={React.forwardRef(({ onClick }, ref) => (
                  <NavLink ref={ref} onClick={onClick} className="menu-top-icon">
                    <FaBell color="#fff" size={18} />
                    {unread && <Styled.NotificationUnreadIcon />}
                  </NavLink>
                ))}
              />
              <Dropdown.Menu as={Notifications} />
            </Dropdown>
            <Company />
            <Nav>
              <Styled.NavDropdown
                title={user?.username ? user.username.split(' ')[0] : 'Conta'}
                className="nav-header profile"
              >
                <NavDropdown.Item as={Link} to="/conta">
                  <span>Ver perfil</span>
                </NavDropdown.Item>

                <NavDropdown.Item
                  as={Link}
                  to="#"
                  onClick={(event) => {
                    event.preventDefault();
                    Controller.logout();
                  }}
                >
                  <span>Sair</span>
                </NavDropdown.Item>
              </Styled.NavDropdown>
            </Nav>
          </div>
        </Navbar.Collapse>
      </Styled.Navbar>
    </>
  );
}
